import { clarity } from "react-microsoft-clarity";
import { TokenHelper } from "./components/shared/TokenHelper";

/**
 * Initialises analytics tracking with Microsoft Clarity.
 */
export function initClarity() {
  const clarityKey = process.env.REACT_APP_CLARITY_KEY;
  if (!clarityKey) {
    console.log("Clarity key not found, skipping Clarity initialization");
    return;
  }

  clarity.init(clarityKey);

  // Identify the user if they have already logged in
  const tokenHelper = new TokenHelper({});
  const username = tokenHelper.getUsername();
  if (username != null) {
    clarity.identify(username, {});
  }
}
